<template>
  <vue-final-modal
    v-model="isOpen"
    classes="modal-overlay-container"
    content-class="modern-modal-content"
    @before-close="closeModal"
  >
    <div class="modal-header bg-warning-soft">
      <div class="header-text-container">
        <div class="title-wrapper">
          <div class="title-icon text-warning bg-white shadow-sm">
            <i class="fas fa-exclamation-triangle fs-5"></i>
          </div>
          <h5 class="modal-title text-dark">Ad Hoc Assignment Warning</h5>
        </div>
      </div>
      <button type="button" class="close-button bg-white" @click="closeModal" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="modal-body p-4 text-center">
      <p class="fs-5 text-dark fw-medium mb-0">
        This video has already been assigned within the last 30 days.
      </p>
      <p class="text-muted mt-2 mb-0">
        Please confirm you wish to continue.
      </p>
    </div>

    <div class="modal-footer bg-warning-soft border-top-0">
      <button type="button" class="btn btn-secondary bg-white" @click="closeModal">Cancel</button>
      <button
        type="button"
        class="btn btn-warning fw-bold text-dark border-0 shadow-sm px-4"
        @click="confirmProceed"
      >
        Continue
      </button>
    </div>
  </vue-final-modal>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue';

const props = defineProps(['modelValue']);
const emit = defineEmits(['update:modelValue', 'confirm']);

const isOpen = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
});

const closeModal = () => {
  isOpen.value = false;
};

const confirmProceed = () => {
  isOpen.value = false;
  emit('confirm');
};
</script>

<style scoped>
:deep(.modal-overlay-container) {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  z-index: 1050;
}

:deep(.modern-modal-content) {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  border: none !important;
  padding: 0;
  margin: 0 1rem;
  overflow: hidden;
}

.bg-warning-soft {
  background-color: #fffbeb !important;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #fde68a;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
}

.modal-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
}

.close-button {
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #94a3b8;
  transition: all 0.2s;
}

.close-button:hover { background-color: #fee2e2; color: #dc3545; transform: rotate(90deg); }

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem 1.5rem;
  gap: 0.75rem;
}

.btn {
  padding: 0.6rem 1.5rem;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.2s;
}

.btn-secondary { color: #64748b; border: 1px solid #e2e8f0; }
.btn-secondary:hover { background-color: #f1f5f9 !important; color: #1e293b; }
.btn-warning:hover { background-color: #f59e0b !important; color: white !important; }
</style>